import { combineReducers } from "redux";
import { Entities, Preset } from "~/normalizr/entities";
import { createEntityReducer, EntityNames } from "~/Redux/Entities";

export type Presets = Entities<Partial<Preset>>;

export interface EntitiesState {
    presets?: Presets;
}

export const presetsEntityReducer = {
    presets: createEntityReducer(EntityNames.presets, { ignoreCleanEntities: true }),
};

export const createPresetsEntityReducer = combineReducers<EntitiesState>(presetsEntityReducer);
